// Import Components
import UsedInSection from 'components/common/UsedInSection';
//Import Constants
import { l, StateModesLabels, CustomerJourneyStatusLabels, TimeZonePack, PARTNER_SETTINGS } from 'constants/common';
// Import Enums
import { PermissionEnum } from 'enums';
//Import Services
import { Helpers } from 'services';

const { customMomentWithoutTimezoneConversion } = Helpers;

const defaultClassNames = {
    pair: 'key-value-info-content',
    key: 'key-value-items-title',
    value: 'key-value-items-subtitle',
    skeleton: 'key-value-items-skeleton',
};

const infoItemsConfig = (t, dateTimeFormat, hasPartnerSettings, hasPermission) => {
    return {
        predefinedRegions: {
            label: l.Regions,
            classNames: { ...defaultClassNames },
        },
        predefinedCategories: {
            label: l.Categories,
            classNames: { ...defaultClassNames },
        },
        workflowId: {
            label: l.WorkflowId,
            classNames: { ...defaultClassNames },
        },
        title: {
            label: l.Title,
            classNames: { ...defaultClassNames },
        },
        description: {
            label: l.Description,
            classNames: { ...defaultClassNames },
        },
        isNonMarketing: {
            label: l.NonMarketing,
            format: (isNonMarketing) => (isNonMarketing ? t(l.Yes) : t(l.No)),
            classNames: { ...defaultClassNames },
            hidden: !hasPermission(PermissionEnum.ManageNonMarketingCampaign),
        },
        isPublic: {
            label: l.Public,
            format: (isPublic) => (isPublic ? t(l.Yes) : t(l.No)),
            classNames: { ...defaultClassNames },
            hidden: !hasPartnerSettings(PARTNER_SETTINGS.IsAllowABTest),
        },
        startDate: {
            label: l.AutoStart,
            format: (createdDate) => customMomentWithoutTimezoneConversion(createdDate).format(dateTimeFormat),
            classNames: { ...defaultClassNames },
        },
        endDate: {
            label: l.AutoEnd,
            format: (endDate) => customMomentWithoutTimezoneConversion(endDate).format(dateTimeFormat),
            classNames: { ...defaultClassNames },
        },
        timeZone: {
            label: l.TimeZone,
            format: (timeZone) => TimeZonePack[timeZone],
            classNames: { ...defaultClassNames },
        },
        mode: {
            label: l.Mode,
            format: (mode) => StateModesLabels[mode],
            classNames: { ...defaultClassNames },
        },
        status: {
            label: l.Status,
            format: (status) => CustomerJourneyStatusLabels[status],
            classNames: { ...defaultClassNames },
        },
        user: { label: l.User, classNames: { ...defaultClassNames } },
        createdDate: {
            label: l.CreatedDate,
            format: (createdDate) => customMomentWithoutTimezoneConversion(createdDate).format(dateTimeFormat),
            classNames: { ...defaultClassNames },
        },
        lastModified: {
            label: l.LastModified,
            format: (createdDate) => customMomentWithoutTimezoneConversion(createdDate).format(dateTimeFormat),
            classNames: { ...defaultClassNames },
        },
        lastModifier: { label: l.LastModifier, classNames: { ...defaultClassNames } },
        usedIn: {
            label: l.UsedIn,
            isLoading: true,
            renderer: (data) => (
                <div className="customer-journey-used-in-section">
                    <UsedInSection
                        isLoadingUsedIn={false}
                        usedInData={data}
                        isVisible={true}
                        notUsedInDisplayNameKey={l.NotUsed}
                    />
                </div>
            ),
        },
        hasBudget: {
            label: l.HasActiveBudget,
            format: (hasBudget) => (hasBudget ? t(l.Yes) : t(l.No)),
            classNames: { ...defaultClassNames },
        },
    };
};

export { infoItemsConfig };
